import { Injectable } from "@angular/core";

export class leftMenu {
    text:string;
    icon?:string;
    subItems?:leftMenu[];
}
export const  produttori: leftMenu[] = [{text: 'Invia Mail',icon: "product"}, {text: 'Invia fatttura',icon: "money"}]
export const navigation = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'Aziende',
    path: '/aziende',
    icon: 'globe'
  },
  {
    text: 'Banners',
    path: '/banner',
    icon: 'image'
  },
  {
    text: 'Categorie',
    path: '/categorie',
    icon: 'orderedlist'
  },
  {
    text: 'Eventi',
    path: '/eventi',
    icon: 'favorites'
  },
  {
    text: 'Video',
    path: '/video',
    icon: 'video'
  },
  {
    text: 'Utenti',
    path: '/utenti',
    icon: 'card'
  },
  {
    text: 'Media Press',
    icon: 'mention',
    expanded: false,
    items: [
      {
        text: 'Edizioni',
        icon: 'bookmark',
        path: '/edizioni'
      },
      {
        text: 'Articoli',
        icon: 'edit',
        path: '/articoli'
      },

      ]
  },

];

@Injectable({
    providedIn: 'root'
  })
  export class leftMenuService {

    constructor() { }


    getService(e:string){
      if (e=='produttori'){return produttori}
    }


  }
